/**
 * Set up routing for all UserAnswer views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import userAnswer views
import CreateUserAnswer from './views/CreateUserAnswer.js.jsx';
import UserAnswerList from './views/UserAnswerList.js.jsx';
import SingleUserAnswer from './views/SingleUserAnswer.js.jsx';
import UpdateUserAnswer from './views/UpdateUserAnswer.js.jsx';

class UserAnswerRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user-answers" component={UserAnswerList} />
        <YTRoute login={true} exact path="/user-answers/new" component={CreateUserAnswer} />
        <Route exact path="/user-answers/:userAnswerId" component={SingleUserAnswer}/>
        <YTRoute login={true} exact path="/user-answers/:userAnswerId/update" component={UpdateUserAnswer}/>
      </Switch>
    )
  }
}

export default UserAnswerRouter;



// WEBPACK FOOTER //
// modules/userAnswer/UserAnswerRouter.js.jsx